import React, {ReactElement, ReactNode} from 'react'
import {
  EditorWrap,
  IconWrap,
  Label,
  RightIconWrapper,
  StyledTextEditor,
  TextEditorWrapper,
  Wrapper
} from '../../../../../components/library/text-editor/styles'
import SVGHelp from '../../../../../assets/icons/information-small.svg'
import {Tooltip} from '../../../../../components/library/tooltip/tooltip'

export type InputProps = {
  label: string
  icon?: ReactNode
  rightIcon?: ReactNode
  upLabel?: string
  readOnly?: boolean
  onChange?: (value: string) => void
  pattern?: RegExp | string
  compact?: boolean
  testId?: string
  help?: string | ReactElement
  wrapperStyle?: React.CSSProperties
} & Omit<React.HTMLProps<HTMLInputElement>, 'onChange' | 'pattern'>

export const Input = ({
  label,
  icon,
  upLabel,
  readOnly,
  onChange,
  rightIcon,
  compact,
  testId,
  help,
  ...props
}: InputProps) => {
  const [focused, setFocused] = React.useState<boolean>(false)
  // consider empty string as undefined, but not other falsy values
  const valueDefined =
    props.value || (props.value !== undefined && props.value !== '')
  return (
    <TextEditorWrapper
      style={props.wrapperStyle ?? props.style}
      className={compact ? 'compact' : undefined}
      readOnly={readOnly}
    >
      {icon ? <IconWrap>{icon}</IconWrap> : null}
      <EditorWrap data-testid={testId}>
        <Wrapper
          className={
            valueDefined || props.placeholder || focused ? 'labelUp' : ''
          }
        >
          {!compact ? (
            <Label>
              {valueDefined || focused || readOnly
                ? upLabel
                  ? upLabel
                  : label
                : label}
            </Label>
          ) : null}
          <StyledTextEditor>
            <input
              {...props}
              pattern={props.pattern ? String(props.pattern) : undefined}
              readOnly={readOnly}
              onFocus={e => {
                if (!readOnly) {
                  setFocused(true)
                }
                if (props.onFocus) {
                  props.onFocus(e)
                }
              }}
              onBlur={e => {
                setFocused(false)
                if (props.onBlur) {
                  props.onBlur(e)
                }
              }}
              onChange={e => {
                if (props.pattern) {
                  if (e.target.value.match(props.pattern)) {
                    onChange?.(e.target.value)
                  }
                } else {
                  onChange?.(e.target.value)
                }
              }}
            />
          </StyledTextEditor>
          {rightIcon ? (
            <RightIconWrapper>{rightIcon}</RightIconWrapper>
          ) : help ? (
            <RightIconWrapper>
              <Tooltip
                content={help}
                asPortal={true}
                position="left"
                wrapContent={true}
              >
                <SVGHelp />
              </Tooltip>
            </RightIconWrapper>
          ) : null}
        </Wrapper>
      </EditorWrap>
    </TextEditorWrapper>
  )
}
